var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.onlyCopyright ? [_c('div', {
    staticClass: "container_fluid phone footer-phone"
  }, [_c('div', {
    staticClass: "col-ms-12",
    staticStyle: {
      "width": "272px",
      "margin": "auto"
    }
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/logo_light_gray.svg"),
      "alt": "Финсайт"
    }
  })]), _c('p', {
    staticClass: "copyright"
  }, [_vm._v(" © Любое использование либо копирование материалов сайта, элементов дизайна и оформления допускается лишь с письменного разрешения правообладателя и при указании ссылки на первоисточник Финсайт ")])], 1)])] : [_c('div', {
    staticClass: "container_fluid pc footer-pc"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row row-full-width footer"
  }, [_c('div', {
    staticClass: "col-xs-3 col-sm-3 col-md-3"
  }, [_c('ul', [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/logo_gray.svg?v=2"),
      "alt": "Финсайт"
    }
  })]), _c('p', {
    staticClass: "copyright"
  }, [_vm._v(" © Любое использование либо копирование материалов сайта, элементов дизайна и оформления допускается лишь с письменного разрешения правообладателя и при указании ссылки на первоисточник Финсайт ")])], 1)]), _vm._m(0), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-3 navigations"
  }, [_c('h6', [_vm._v("Рубрики")]), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/category/lifehacks"
    }
  }, [_vm._v("Лайфхаки")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/category/knowledge"
    }
  }, [_vm._v("Знания")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/category/tests"
    }
  }, [_vm._v("Тесты")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/category/reviews"
    }
  }, [_vm._v("Ревью")])], 1)])]), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 navigations"
  }, [_c('h6', [_vm._v("Сервисы")]), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/journal"
    }
  }, [_vm._v("Журнал")])], 1), _vm.invType ? [_vm.invType === 1 ? [_c('li', [_c('router-link', {
    class: {
      active: _vm.section === '/investments'
    },
    attrs: {
      "to": "/investments"
    }
  }, [_vm._v("Инвестиции")])], 1)] : [_c('li', [_c('router-link', {
    class: {
      active: _vm.section === '/landing-invest'
    },
    attrs: {
      "to": "/landing-invest"
    }
  }, [_vm._v("Инвестиции")])], 1)]] : [_c('li', [_c('router-link', {
    attrs: {
      "to": "/login-invest"
    }
  }, [_vm._v("Инвестиции")])], 1)], _vm._m(1)], 2)]), false ? _c('div', {
    staticClass: "col-xs-2 col-sm-12 col-md-2"
  }, [_vm._m(2)]) : _vm._e()])])]), _c('div', {
    staticClass: "container_fluid phone footer-phone"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: " row-full-width footer "
  }, [_c('div', {
    staticClass: "col col-ms-6"
  }, [_c('ul', [_c('h6', {
    staticClass: "footer-subtitle"
  }, [_vm._v("Сервисы")]), _c('li', [_c('router-link', {
    attrs: {
      "to": "/journal"
    }
  }, [_vm._v("Журнал")])], 1), _vm.invType ? [_vm.invType === 1 ? [_c('li', [_c('router-link', {
    class: {
      active: _vm.section === '/investments'
    },
    attrs: {
      "to": "/investments"
    }
  }, [_vm._v("Инвестиции")])], 1)] : [_c('li', [_c('router-link', {
    class: {
      active: _vm.section === '/landing-invest'
    },
    attrs: {
      "to": "/landing-invest"
    }
  }, [_vm._v("Инвестиции")])], 1)]] : [_c('li', [_c('router-link', {
    attrs: {
      "to": "/login-invest"
    }
  }, [_vm._v("Инвестиции")])], 1)], _vm._m(3)], 2)]), _c('div', {
    staticClass: "col col-ms-6"
  }, [_c('ul', [_c('h6', {
    staticClass: "footer-subtitle"
  }, [_vm._v("Рубрики")]), _c('li', [_c('router-link', {
    attrs: {
      "to": "/category/lifehacks"
    }
  }, [_vm._v("Лайфхаки")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/category/knowledge"
    }
  }, [_vm._v("Знания")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/category/test"
    }
  }, [_vm._v("Тесты")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/category/reviews"
    }
  }, [_vm._v("Ревью")])], 1)])])]), _vm._m(4), _c('div', [false ? _c('div', {
    staticClass: "col col-ms-6"
  }, [_vm._m(5)]) : _vm._e(), _c('div', {
    staticClass: "col-ms-12 mt-5"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/logo_light_gray.svg"),
      "alt": "Финсайт"
    }
  })]), _c('p', {
    staticClass: "copyright"
  }, [_vm._v(" © Любое использование либо копирование материалов сайта, элементов дизайна и оформления допускается лишь с письменного разрешения правообладателя и при указании ссылки на первоисточник Финсайт ")])], 1)])])])]], 2);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-3 navigations"
  }, [_c('h6', [_vm._v("Редакция")]), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/about"
    }
  }, [_vm._v("О сервисе")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/feedback"
    }
  }, [_vm._v("Контакты")])]), _c('li', [_c('a', {
    attrs: {
      "rel": "nofollow",
      "href": "/oferta.pdf"
    }
  }, [_vm._v("Оферта")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/privacy"
    }
  }, [_vm._v("Политика конфиденциальности")])])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "https://t.me/Finsite_bot",
      "target": "_blank"
    }
  }, [_vm._v("Консультации")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', [_c('li', [_vm._v("Документы")]), _c('li', [_c('a', {
    attrs: {
      "rel": "nofollow",
      "href": "/oferta.pdf"
    }
  }, [_vm._v("Оферта")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/privacy"
    }
  }, [_vm._v("Политика конфиденциальности")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "https://t.me/Finsite_bot",
      "target": "_blank"
    }
  }, [_vm._v("Консультации")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row-full-width footer "
  }, [_c('div', {
    staticClass: "col col-ms-6"
  }, [_c('ul', [_c('h6', {
    staticClass: "footer-subtitle"
  }, [_vm._v("Редакция")]), _c('li', [_c('a', {
    attrs: {
      "href": "/about"
    }
  }, [_vm._v("О сервисе")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/feedback"
    }
  }, [_vm._v("Контакты")])]), _c('li', [_c('a', {
    attrs: {
      "rel": "nofollow",
      "href": "/oferta.pdf"
    }
  }, [_vm._v("Оферта")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/privacy"
    }
  }, [_vm._v("Политика"), _c('br'), _vm._v(" конфиденциальности")])])])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', [_c('h6', {
    staticClass: "footer-subtitle"
  }, [_vm._v("Документы")]), _c('li', [_c('a', {
    attrs: {
      "rel": "nofollow",
      "href": "/oferta.pdf"
    }
  }, [_vm._v("Оферта")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/privacy"
    }
  }, [_vm._v("Политика конфиден-"), _c('br'), _vm._v("циальности")])])]);
}]

export { render, staticRenderFns }